import {MarkdownText} from '@hconnect/uikit/src/lib2'
import {LabelRegular, Icon} from '@hm/fundamental'
import {mdiClockOutline, mdiPaperclip} from '@mdi/js'
import {Box} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'
import {JobsToBeDoneInsightDetails} from '../types'

type Props = {
  insight: JobsToBeDoneInsightDetails
  editedAtFormatted: string | null
  onClick: () => void
}

export const JtbdInsightDetails = ({insight, editedAtFormatted, onClick}: Props) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const hasAttachments = insight.attachments && insight.attachments.length > 0

  return (
    <Box onClick={onClick}>
      <MarkdownText>{insight.description}</MarkdownText>
      <Box sx={{display: 'flex', alignItems: 'center', gap: 2, mt: 0.5}}>
        {insight.timeSpent && (
          <Box sx={{display: 'flex', alignItems: 'center', gap: 0.5}}>
            <Icon path={mdiClockOutline} size="regular" />
            <LabelRegular className="text-foreground_faded" style={{fontSize: '11px'}}>
              {insight.timeSpent}
            </LabelRegular>
          </Box>
        )}
        {editedAtFormatted && insight.lastUpdatedBy && (
          <LabelRegular className="text-foreground_faded" style={{fontSize: '11px'}}>
            {t('jobsToBeDone.details.edited')} {editedAtFormatted}
          </LabelRegular>
        )}
        {hasAttachments && (
          <Box sx={{display: 'flex', alignItems: 'center', gap: 0.5}}>
            <Icon path={mdiPaperclip} size="regular" />
            <LabelRegular className="text-foreground_faded" style={{fontSize: '11px'}}>
              {insight.attachments.length}
            </LabelRegular>
          </Box>
        )}
      </Box>
    </Box>
  )
}
